<template>
  <v-dialog v-model="visible" persistent :max-width="width" class="us-share-qrcode">
    <v-card>
        <v-toolbar dark color="primary" style="height:46px;" class="us-qrcode-toolbar">
            <v-toolbar-title>{{title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="curVisible = false">
                <v-icon >fa fa-times</v-icon>
            </v-btn>
        </v-toolbar>
        <!-- <v-card-title class="headline">{{title}}</v-card-title> -->
        <v-card-text style="padding:0.1rem;padding-left:0.4rem;padding-top:0.42rem;" :style="{height:height}">
            <div id="qrcode" ref="qrcode" />
            <div style="text-align:center;padding-bottom:0.5rem;color:#F56C6C;">
                有效期 {{expiry}} 分钟.
            </div>
        </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: 'https://www.baidu.com/'
    },
    width: {
      type: Number,
      default: 200
    },
    height: {
      type: Number,
      default: 190
    },
    title: {
      type: String,
      default: '标题'
    },
    visible: {
      type: Boolean,
      default: false
    },
    expiry: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      curQrContent: ''
    }
  },
  computed: {
    curVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$refs.qrcode.innerHTML = ''
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible(val, oldval) {
      if (val) {
        this.createQrCode()
      }
    },
    content(val) {
      this.curQrContent = val
    }
  },
  mounted() {

  },
  created() {

  },
  methods: {
    createQrCode() {
      var that = this
      that.$nextTick(() => {
        var qrCode = new QRCode('qrcode', {
          width: that.width - 25,
          height: that.height - 30,
          text: that.curQrContent, // 二维码内容
          colorDark: '#000',
          colorLight: '#fff',
          correctLevel: QRCode.CorrectLevel.L
        })
        console.log('qrCode', qrCode)
      })
    },
    setQrContent(content) {
      var that = this
      that.curQrContent = content
    }
  }
}
</script>

<style scoped>

.us-el-dialog /deep/ .el-dialog__body {
  padding-top: 0px;
}

.us-el-dialog /deep/ .el-dialog__headerbtn {
  font-size: 30px;
}

#qrcode {
  display: inline-block;
  border: 6px solid rgb(255, 255, 255);
  border-radius: 5px;
}
/* #qrcode img {
  width: 132px;
  height: 132px;
  background-color: #fff;
  padding: 6px;
} */

.headline{
  padding: 10px 14px 6px !important;
  font-size: 1.1rem !important;
}

.us-qrcode-toolbar >>> .v-toolbar__content{
  height:46px !important;
}

</style>
